module.exports = __webpack_public_path__ + "media/dashboard/assets/images/audit_log_icons/shield-46449cfdf21345c338ab6c5793577304.svg";